import React, { ReactNode } from "react";
import { Link as RouterLink } from "react-router";
import { Link, LinkProps } from "@mui/material";

const isInAppPath = (href: string) =>
  href.startsWith("/") && !href.startsWith("//");

export interface LinkWithRoutingProps extends Omit<LinkProps, "href"> {
  children: ReactNode;
  href?: string;
  testId?: string;
}

/**
 * Renders an in-app path through the router and anything else — a mandator's
 * external instrument page, say — as a plain anchor.
 *
 * Routing matters for two reasons: a bare `<a href="/investments/1">` resolves
 * against the origin, dropping the router's basename (`/v2` on hosted) and
 * landing on an unknown page, and it reloads the whole app instead of
 * navigating client-side.
 */
export const LinkWithRouting = ({
  href,
  testId,
  children,
  ...rest
}: LinkWithRoutingProps) => {
  const destination =
    href && isInAppPath(href) ? { component: RouterLink, to: href } : { href };

  return (
    <Link {...rest} data-testid={testId} {...destination}>
      {children}
    </Link>
  );
};
